import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  themes = ['light-theme', 'dark-theme'];

  setTheme(theme: string) {
    document.body.classList.remove(...this.themes);
    document.body.classList.add(theme);
    if (!this.themes.includes(theme)) {
      this.themes.push(theme);
    }
    localStorage.setItem('pref_theme', theme);
  }

  checkThemeOnStart() {
    const pref_theme = localStorage.getItem('pref_theme');
    if (pref_theme) {
      this.setTheme(pref_theme);
    }
  }

  currentTheme(): string {
    return document.body.classList.toString();
  }
}
